import React from "react";
import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  0% {
    transform: translateX(-150%);
  }
  50% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(150%);
  }
`;

const SkeletonWrapper = styled.div`
  position: relative;
  overflow: hidden;
  background-color: #e0e0e0;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  margin-top: 5px;
`;

const Shimmer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
  height: 100%;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.6) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  animation: ${shimmer} 1.5s infinite linear;
`;

const HiddenContent = styled.div`
  visibility: hidden;
`;

const CenteredText = styled.div`
  position: absolute;
  color: #888;
  font-size: 1rem;
  font-weight: 500;
  text-align: center;
  pointer-events: none;
`;

const SkeletonLoader = ({
  children,
  isLoading,
  className,
  minHeight,
  minWidth,
  text, // New prop
}) => {
  if (!isLoading) return children;

  return (
    <SkeletonWrapper
      className={className}
      style={{
        minHeight: minHeight || "auto",
        minWidth: minWidth || "auto",
      }}
    >
      <Shimmer />
      {text && <CenteredText>{text}</CenteredText>}
      <HiddenContent>{children}</HiddenContent>
    </SkeletonWrapper>
  );
};

export default SkeletonLoader;